import { render } from "./mg-article.vue?vue&type=template&id=33c7122f&scoped=true"
import script from "./mg-article.vue?vue&type=script&lang=js"
export * from "./mg-article.vue?vue&type=script&lang=js"

import "./mg-article.vue?vue&type=style&index=0&id=33c7122f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c7122f"]])

export default __exports__